// @ts-nocheck
import { initialState } from './reducer';
// import * as reducer from './reducer';
const bookmarksSelector = (state) => state['model/bookmarks'] || initialState;

export const getUserGridBookmarks = (state, tableId) => {
	return bookmarksSelector(state)?.[tableId] || [];
};
